import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

const PipelinesWorkspaceDynamicPipelinesPageLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () => import('./dynamic-pipelines'),
});

// eslint-disable-next-line import/no-default-export
export default PipelinesWorkspaceDynamicPipelinesPageLoadable;
